export const mockDataLine = [
  {
    "id": "N",
    "color": "hsl(192, 70%, 50%)",
    "data": [
      {
        "x": "jan",
        "y": 217
      },
      {
        "x": "fev",
        "y": 126
      },
      {
        "x": "mar",
        "y": 79
      },
      {
        "x": "avr",
        "y": 50
      },
      {
        "x": "mai",
        "y": 176
      },
      {
        "x": "juin",
        "y": 180
      },
      {
        "x": "juil",
        "y": 140
      },
      {
        "x": "aou",
        "y": 282
      },
      {
        "x": "sep",
        "y": 285
      },
      {
        "x": "oct",
        "y": 232
      },
      {
        "x": "nov",
        "y": 100
      },
      {
        "x": "dec",
        "y": 261
      }
    ]
  },
  {
    "id": "N1",
    "color": "hsl(319, 70%, 50%)",
    "data": [
      {
        "x": "jan",
        "y": 130
      },
      {
        "x": "fev",
        "y": 99
      },
      {
        "x": "mar",
        "y": 65
      },
      {
        "x": "avr",
        "y": 81
      },
      {
        "x": "mai",
        "y": 211
      },
      {
        "x": "juin",
        "y": 127
      },
      {
        "x": "juil",
        "y": 9
      },
      {
        "x": "aou",
        "y": 25
      },
      {
        "x": "sep",
        "y": 262
      },
      {
        "x": "oct",
        "y": 144
      },
      {
        "x": "nov",
        "y": 207
      },
      {
        "x": "dec",
        "y": 22
      }
    ]
  }
]


export const mockDataLine2 = [
  {
    "id": "N",
    "color": "hsl(192, 70%, 50%)",
    "data": [
      {
        "x": "jan",
        "y": 21
      },
      {
        "x": "fev",
        "y": 12
      },
      {
        "x": "mar",
        "y": 26
      },
      {
        "x": "avr",
        "y": 50
      },
      {
        "x": "mai",
        "y": 17
      },
      {
        "x": "juin",
        "y": 18
      },
      {
        "x": "juil",
        "y": 14
      },
      {
        "x": "aou",
        "y": 28
      },
      {
        "x": "sep",
        "y": 28
      },
      {
        "x": "oct",
        "y": 23
      },
      {
        "x": "nov",
        "y": 10
      },
      {
        "x": "dec",
        "y": 26
      }
    ]
  },
  {
    "id": "N1",
    "color": "hsl(39, 70%, 50%)",
    "data": [
      {
        "x": "jan",
        "y": 13
      },
      {
        "x": "fev",
        "y": 50
      },
      {
        "x": "mar",
        "y": 65
      },
      {
        "x": "avr",
        "y": 36
      },
      {
        "x": "mai",
        "y": 21
      },
      {
        "x": "juin",
        "y": 12
      },
      {
        "x": "juil",
        "y": 9
      },
      {
        "x": "aou",
        "y": 25
      },
      {
        "x": "sep",
        "y": 26
      },
      {
        "x": "oct",
        "y": 14
      },
      {
        "x": "nov",
        "y": 20
      },
      {
        "x": "dec",
        "y": 22
      }
    ]
  }
]
